import React from 'react';
import Withdraw from ".";
import authRoles from "../../utils/auth.roles";
import WithdrawDetail from "./WithdrawDetail";
import WithdrawStatus from "./WithdrawStatus";
import { Navigate } from 'react-router-dom'
const WithdrawRoutes = {
  auth: authRoles.user,
  kyc: false,
  routes: [
    {
      path: "/withdraw",
      component: () => <Navigate to="/withdraw/0" />,
      exact: true,
    },
    {
      path: "/withdraw/:screen",
      component: Withdraw,
      exact: true,
    },
    {
      path: "/withdraw/:screen/:type",
      component: Withdraw,
      exact: true,
    },
    {
      path: "/withdraw/:screen/:type/:extra",
      component: Withdraw,
      exact: true,
    },
    {
      path: "/withdraw/status",
      component: WithdrawStatus,
      exact: true
    },
    {
      path: "/withdraw/status/:id",
      component: WithdrawStatus,
      exact: true
    },
    {
      path: "/withdraw/details/:id",
      component: WithdrawDetail,
      exact: true
    }
  ],
};
export default WithdrawRoutes;
